let isHidden = false;

const variantsJSON = document.querySelector(
  "[data-product-variants-json]"
).innerHTML;
const variantsObj = JSON.parse(variantsJSON);

const variantSearch = window.location.search;

if (variantSearch !== "") {
  if (variantSearch.includes("variant=")) {
    const id = parseInt(variantSearch.split("variant=")[1]);

    const foundVariant = variantsObj.find((variant) => {
      return variant.id === id;
    });

    if (foundVariant !== undefined) {
      const titleParts = foundVariant.public_title.split("#");
      if (titleParts.length > 1) {
        if (titleParts[1] === "Hide" || titleParts[1] === "hide") {
          isHidden = true;
        }
      }

      if (isHidden) {
        const foundAltVariant = variantsObj.find((variant) => {
          return variant.public_title.includes("#Hide") == false;
        });

        if (foundAltVariant !== undefined) {
          const id = foundAltVariant.id;
          const url =
            window.location.origin +
            window.location.pathname +
            "?variant=" +
            id;
          location.replace(url);
        } else {
          const url = window.location.origin + window.location.pathname;
          location.replace(url);
        }
      }
    }
  }
}
